type AnimateScrollSchema = {
    fromValue: number;
    toValue: number;
    onUpdate: (value: number, callBack: void) => void;
    onComplete: () => void;
    duration?: number;
};

const easing = (time: number): number => 1 - --time * time * time * time;

const getValue = (start: number, end: number, elapsed: number, duration: number): number => {
    if (elapsed > duration) {
        return end;
    }

    return start + (end - start) * easing(elapsed / duration);
};

export const animateScroll = ({ fromValue, toValue, onUpdate, onComplete, duration = 1500 }: AnimateScrollSchema) => {
    const startTime = performance.now();

    const tick = () => {
        const elapsed = performance.now() - startTime;

        window.requestAnimationFrame(() => {
            const scrollIndex = getValue(fromValue, toValue, elapsed, duration);
            const nextCallback = elapsed <= duration ? tick() : onComplete();

            return onUpdate(scrollIndex, nextCallback);
        });
    };

    tick();
};
